import { useEffect } from "react";
import { Calendar, Modal } from "antd";
import { YhBox } from "@/components/YhBox";
import { useTasteModel } from "../tasteModel";
import useNavModel from "@/model/navModel";
import moment from "moment"
import YhTag from "@/components/YhTag";
import { ToolOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { IRestaurantDetial } from "@/views/restaurant/restaurantTypes";
import { mealService } from "@/views/meal/mealService";
import { IMealFields } from "@/views/meal/mealTypes";
import { IMealTypeEnum, IMealTypeObj } from "@/types/AppEnums";
type statusType = {
    "cold": string,
    "hot": string,
    "staple": string,
    "other": string,
    [key: string]: any
}
const statusColor: statusType = {
    "cold": "green",
    "hot": "red",
    "staple": "cyan",
    "other": "lime",

}
export const CalendarBox = () => {
    const { dataSource, homeInfo, canteenId,
        loadData, setDayMeal,
        setHomeInfo,
        setMeal,
        setMealIdList,
        setTimeStartInEnd, setTasteList,
    } = useTasteModel();
    const { addNav } = useNavModel();

    useEffect(() => {
        setConteen()
        return () => {
            setHomeInfo(null);
        }
    }, []);

    const setConteen = async () => {
        let { retData: { data: mealData } } = await mealService.page({
            canteenId,
            "page": {
                "pageSize": 10,
                "pageNum": 1
            }
        });
        setMealIdList(mealData)
        let setMealModal = Modal.confirm({
            title: <span style={{ fontSize: "20px", fontWeight: "bold" }}>请选择餐别</span>,
            centered: true,
            closable: false,
            icon: <ToolOutlined />,
            className: "login-shop-modal",
            content: <div className="login-shop-container">
                {
                    mealData && mealData.length > 0 ? mealData.map(item => (
                        <span key={item.id} onClick={() => setFoodMenu(item, canteenId, setMealModal)}>{IMealTypeObj[item.mealType as IMealTypeEnum]}</span>
                    )) : <span onClick={() => { addNav("3"); setMealModal.destroy(); }} style={{ background: "#FD8700" }}>去增加餐别</span>
                }
            </div>,
            // onCancel: () => { loginServiceAuth2.Logout(); setLoading(false); }
        });
    }

    //选中餐别 餐厅id 请求到 当前的菜单发布页
    const setFoodMenu = (item: IMealFields, canteenId: string, mealModalInst: any) => {
        let mealId = item.id as string
        setMeal(item.mealType as IMealTypeEnum)
        setHomeInfo({ canteenId, mealId });
        loadData({ canteenId, mealId })
        mealModalInst?.destroy();
    }


    const getListData = (value: any) => {
        let listData: any[] = []
        console.log(dataSource)
        dataSource.forEach((item) => {
            if (moment(item.time).format("YYYY-MM-DD") === value.format("YYYY-MM-DD")) {
                item.foods && item.foods?.map((food) => {
                    let { category, name, id, image, labelName, orderNum } = food
                    listData.push({ category, name, id, image, labelName, orderNum })
                })
            }
        })
        return listData ?? []
    }
    const dateCellRender = (value: any) => {
        const listData = getListData(value)
        return <>
            {/* {listData.length !== 0 && <PlusCircleOutlined onClick={(e) => { e.stopPropagation(); onLook(listData) }} style={{ fontSize: '16px', }} />} */}
            {listData.map(item => (
                <YhTag key={item.name} color={statusColor[item.category]} text={item.name} />
            ))}
        </>
    }
    const onDayChange = (date: any) => {
        let newDataSource = dataSource.filter((item) => {
            if (moment(item.time).format("YYYY-MM-DD") === date.format("YYYY-MM-DD")) {
                return item
            }
        })[0]
        setDayMeal({ ...newDataSource, time: date.format("YYYY-MM-DD") })
        setTasteList([])

    }
    const onPanelChange = (date: any, mode: string) => {
        setTimeStartInEnd(
            {
                startTime: moment(date).startOf('month').format("YYYY-MM-DD"),
                endTime: moment(date).endOf('month').endOf('month').format("YYYY-MM-DD")
            }
        )
        loadData({
            ...homeInfo,
            startTime: moment(date).startOf('month').format("YYYY-MM-DD"),
            endTime: moment(date).endOf('month').endOf('month').format("YYYY-MM-DD"),
        })
    }
    return (
        <YhBox
            title={""}
            style={{
                // width: "783px",
                width: "calc(100vw - 321px)",
                height: "690px",
                marginRight: "15px",
                overflowY: "auto"
            }}
        >
            <Calendar
                dateCellRender={dateCellRender}
                onSelect={onDayChange}
                onPanelChange={onPanelChange}
            // onSelect={() => { console.log('onSelect') }}
            />
        </YhBox>
    )
}